import { Component, inject } from '@angular/core';
import { AuthService } from './_services/auth.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    imports: [RouterLink]
})

export class ForgotPasswordComponent {
  authService = inject(AuthService);
}